import { cashfreeSandbox, cashfreeProd } from "cashfree-dropjs";

function useCasefree(cUID, onPaymentSuccess, onPaymentFailure) {
  const activateCasefreeModal = function (
    amount,
    order_token,
    paymentMethod,
    backendOrderId
  ) {
    const dropConfig = {
      components: ["order-details", "netbanking", "card", "upi"],
      orderToken: order_token,
      onSuccess: function (data) {
        //on payment flow complete
        if (data.order && data.order.status == "PAID")
          onPaymentSuccess(cUID, backendOrderId, order_token);
      },
      onFailure: function (data) {
        //on failure during payment initiation
        document.getElementById("cashfree_div_element").remove();

        onPaymentFailure(backendOrderId, order_token);
      },
      style: {
        //to be replaced by the desired values
        backgroundColor: "#ffffff",
        color: "#11385b",
        fontFamily: "Lato",
        fontSize: "14px",
        errorColor: "#ff0000",
        theme: "light", //(or dark)
      },
    };
    document.querySelector(".checkout-sub-container").style.display = "none";

    const checkout_container = document.getElementById("checkout_container");

    const cashfree_div_element = document.createElement("div");
    cashfree_div_element.setAttribute("id", "cashfree_div_element");
    checkout_container.appendChild(cashfree_div_element);

    const cashfree = new cashfreeSandbox.Cashfree();
    try {
      cashfree.initialiseDropin(cashfree_div_element, dropConfig);
    } catch (err) {
      console.log(err);
    }
  };
  return [activateCasefreeModal];
}

export default useCasefree;
